module.exports = __webpack_public_path__ + "a62e330d249ff3f5bd27978a78c3d1d6.svg";